import { useState, useEffect } from "react";
import { ref, onValue } from "firebase/database";
import { db } from "../api/firebase";

const useFirebaseData = <T = any>(path: string | null): T | undefined => {
  const [data, setData] = useState<T | undefined>(undefined);

  useEffect(() => {
    if (!path) {
      // eslint-disable-next-line react-hooks/set-state-in-effect -- resetting state when subscription path becomes null is intentional
      setData(undefined);
      return;
    }
    const dbRef = ref(db, path);
    const unsubscribe = onValue(dbRef, (snapshot) => setData(snapshot.val()));
    return () => unsubscribe();
  }, [path]);

  return data;
};

export default useFirebaseData;
